import { get, post, put, patch, del } from '../http/http';
// 用户管理
export default {
    getList: (val) => get('/space/account', val), // 查询列表
    getOwners: () => get('/space/owners'), // 根据登录用户权限获取主账号列表
    addList1: (val) => post('/space/account', val), // 添加主账号
    addList2: (val) => post('/space/subsidiary', val), // 添加子账号
    delList: (val) => del(`/space/subsidiary/${val}`), // 删除
    getPower: (val) => get(`/system/listMenuTree/${val}`), // 获取权限
    setPower: (val) => post('/system', val), // 设置权限
    getMenu: (val) => get('/auth/getMenu', val), // 菜单数据
    getInfo: (val) => get('/center/person', val), // 查询用户详情
    email: (val) => patch('/center/person/email', val), // 修改邮箱
    password: (val, config) => patch('/center/person/password', val, config), // 修改密码
    nickname: (val) => patch('/center/person/nickname', val), // 修改昵称
    username: (val) => patch('/center/person/username', val), // 修改用户名
    phone: (val, config) => patch('/center/person/phone', val, config), // 修改手机号
    personIdentify: (val, config) => post('/center/person/identify', val, config), // 校验身份
    changePhoneIdentify: (val, config) => post('/center/person/phone/identify', val, config), // 修改手机验证
    getChangePhoneCode: (val, config) => post('/center/person/phone/code', val, config), // 获取修改手机验证码
    getResetPswPhoneCode: (val, config) =>
      post('/center/person/password/phone-code', val, config), // 获取重置密码手机验证码
    getResetPswEmailCode: (val, config) =>
      post('/center/person/password/email-code', val, config), // 获取重置密码邮箱验证码
    passwordIdentify: (val, config) => post('/center/person/password/identify', val, config), // 重置密码校验身份
    getChangeEmailCode: (val, config) => post('/center/person/email/code', val, config), // 获取修改邮箱验证码
    changeEmail: (val, config) => patch('/center/person/email', val, config), // 修改邮箱
    identifyChangeEmail: (val, config) => post('/center/person/email/identify', val, config) // 修改邮箱校验身份
}
